<!--
 * $Description: 属性配置组件
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年06月17日 13:26:12 +0800
 * @最后修改时间: 2022-04-21 17:10:41
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_PropertyList.vue
-->
<template>
  <v-container class="property_container pa-0 pb-3 rounded-lg" fluid>
    <noContent v-if="items_copy.length == 0" />
    <a-table
      v-else
      :columns="headers"
      :pagination="false"
      :loading="isLoading"
      childrenColumnName="children"
      :showHeader="false"
      rowKey="property_master_code"
      :expandIcon="(props) => customExpandIcon(props)"
      size="small"
      :data-source="items_copy"
      :rowClassName="
        (record, index) => {
          return getCurEdit2(record, listdata) ? '' : 'grey lighten-4';
        }
      "
    >
      <template
        slot="name"
        slot-scope="text, record, index"
        style="background: red"
      >
        <slot name="name">
          <span
            :style="{
              color: getCurEdit2(record, listdata)
                ? 'rgba(0,0,0,0.87)'
                : 'rgba(0,0,0,0.38)',
            }"
          >
            {{ $getCommonLangValue(record.property_master_name) }}
          </span></slot
        >
      </template>
      <template slot="value" slot-scope="text, record, index">
        <div>
          <slot name="value">
            <template v-if="record.changeList.length">
              <div>
                {{
                  getTrueValue(
                    record.changeList,
                    record.data_type,
                    record.prompt_name,
                    record
                  )
                }}
              </div>
            </template>
            <template v-else>
              <span
                v-if="
                  record.prompt_name !== '' &&
                  record.prompt_name !== null &&
                  record.prompt_name !== undefined
                "
              >
                <span v-if="promptArr.indexOf(record.prompt_name) != -1">
                  {{ record.value | getPrompt(record, getPromptValue) }}
                </span>
                <span
                  v-else-if="
                    (record.value === null ? '' : record.value).toString() ==
                      '1' ||
                    (record.value === null ? '' : record.value).toString() ==
                      '0'
                  "
                >
                  {{
                    (record.value === null ? "" : record.value).toString() ==
                    "1"
                      ? $t("label_essweb_system_label_trueLabel")
                      : (record.value === null
                          ? ""
                          : record.value
                        ).toString() == "0"
                      ? $t("label_essweb_system_label_falseLabel")
                      : ""
                  }}
                </span>
                <span v-else>{{ record.value }}</span>
              </span>
              <span v-else-if="record.data_type === 'boolean'">
                {{
                  (record.value === null ? "" : record.value).toString() == "1"
                    ? $t("label_essweb_system_label_trueLabel")
                    : (record.value === null ? "" : record.value).toString() ==
                      "0"
                    ? $t("label_essweb_system_label_falseLabel")
                    : record.value
                }}
              </span>
              <span
                v-else-if="
                  record.data_type === 'int' ||
                  record.data_type === 'String' ||
                  record.data_type === 'bigint'
                "
              >
                {{ record.value }}
              </span>
              <span v-else>{{ record.value }}</span>
            </template>
          </slot>
        </div>
      </template>
      <template slot="action" slot-scope="text, record, index" v-if="!onlyShow">
        <v-btn
          icon
          @click="toEdit(record)"
          :disabled="record | CurEdit(listdata, getCurEdit2)"
          v-if="canEdit"
        >
          <span class="material-icons-round">edit</span>
        </v-btn>
        <v-btn
          icon
          @click="toView(record)"
          v-if="!canEdit && canView"
          :disabled="record | CurEdit(listdata, getCurEdit2)"
        >
          <svg-icon size="24" fill="currentColor" iconClass="viewDetail" />
        </v-btn>
      </template>
      <template slot="footer"></template>
    </a-table>
    <!-- <v-treeview
      :items="items_copy"
      hoverable
      return-object
      expand-icon="arrow_drop_down"
      on-icon="mdi-bookmark"
      off-icon="mdi-bookmark-outline"
      indeterminate-icon="mdi-bookmark-minus"
    >
      <template slot="label" slot-scope="{ item,open,leaf,selected,indeterminate,active}">
        <slot
          name="label"
          :item="item"
          :open="open"
          :leaf="leaf"
          :selected="selected"
          :indeterminate="indeterminate"
          :active="active"
        >
          <v-sheet class="max-width d-flex flex-row flex-nowrap justify-start">
            <div style="width:50%" class="text-left">{{item.name}}</div>
            <span>{{item.value}}</span>
          </v-sheet>
        </slot>
      </template>
      <template slot="prepend" slot-scope="{ item,open,leaf,selected,indeterminate,active}">
        <slot
          name="prepend"
          :item="item"
          :open="open"
          :leaf="leaf"
          :selected="selected"
          :indeterminate="indeterminate"
          :active="active"
        ></slot>
      </template>
      <template slot="append" slot-scope="{ item,open,leaf,selected,indeterminate,active}">
        <slot
          name="append"
          :item="item"
          :open="open"
          :leaf="leaf"
          :selected="selected"
          :indeterminate="indeterminate"
          :active="active"
        >
          <v-btn icon color="primary">
            <span class="material-icons-round">
                edit
              </span>
          </v-btn>
        </slot>
      </template>
    </v-treeview>-->
  </v-container>
</template>
<script>
import Vue from "vue";
import "ant-design-vue/dist/antd.css";
import { Table, Icon } from "ant-design-vue";
Vue.use(Table);
Vue.use(Icon);
// ant-design-vue
import { mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  name: "MrcPropertyList",
  props: {
    items: { default: [], type: [Object, Array] },
    listdata: { default: [], type: [Object, Array] },
    canEdit: { default: true, type: Boolean },
    canView: { default: true, type: Boolean },
    onlyShow: { default: false, type: Boolean },
  },
  computed: {
    ...mapGetters(["isLoading"]),
    items_copy() {
      const that = this;
      // 解决后端返回null报错问题
      if (!this.items) return [];
      else {
        //解决后端uuid重复问题
        this.items.map((item, index) => {
          //避免value=null造成toString()報錯 2021-07-15
          item["value"] = item["value"] === null ? "" : item["value"];
          //2021-08-02 BJ 有些property不显示
          if (
            item["is_display"] !== undefined &&
            Number(item["is_display"]) === 0
          ) {
            that.items.splice(index, 1);
          }
        });
        return that.items;
      }
    },
  },
  data() {
    return {
      curDate: null,
      prompt: {},
      promptArr: [
        "ess_match_method_select",
        "ess_clock_in_calculation_priority_select",
        "ess_att_time_select",
        "ess_workflow_template_select",
        "ess_leave_actual_minutes_property_value_select",
        "ess_att_ot_select",
        "minute_unit_select",
      ],
      headers: [
        {
          title: "name",
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "value",
          dataIndex: "value",
          key: "value",
          width: "30%",
          scopedSlots: { customRender: "value" },
        },
        {
          title: "",
          key: "action",
          width: "30px",
          scopedSlots: { customRender: "action" },
        },
      ],
    };
  },
  watch: {
    // items_copy(val) {
    //   //避免value=null造成toString()報錯 2021-07-15
    //   val.map((item) => {
    //     item["value"] = item["value"] === null ? "" : item["value"];
    //   });
    // },
  },
  mounted() {
    this.getOnlineSystemDate();
    this.getPrompt(this.promptArr);
  },
  filters: {
    CurEdit: function (record, listdata, callback) {
      return !callback(record, listdata);
    },
    CurEdit2: function (record, callback) {
      return callback(record);
    },
    getPrompt: function (value, record, callback) {
      return callback(record, value);
    },
  },
  methods: {
    getPrompt: async function (arr) {
      const that = this;
      arr.map((item) => {
        that.prompt[item] = [];
      });
      await arr.forEach((pro, index) => {
        that
          .$findPrompt({
            prompt_name: pro,
          })
          .then((res) => {
            that.prompt[pro] = JSON.parse(JSON.stringify(res.data));
            //重新生成一个可枚举对象
            if (index == arr.length - 1)
              that.prompt = JSON.parse(JSON.stringify(that.prompt));
          });
      });
    },
    toEdit: function (item) {
      this.$emit("edit", item);
    },
    toView: function (item) {
      this.$emit("view", item);
    },
    getPromptValue: function (record, value) {
      if (this.promptArr.indexOf(record.prompt_name) != -1) {
        if (this.prompt[record.prompt_name] == undefined) {
          return "";
        } else {
          let prompts = this.prompt[record.prompt_name].find(
            (ele) => String(ele.value_field) === String(value)
          );
          return this.$getCommonLangValue(
            prompts ? prompts["view_fields"] : ""
          );
        }
      } else {
        return value;
      }
    },
    getCurEdit: function (record) {
      // 此方法已被淘汰，使用getCurEdit2
      let code = "";
      let curRecord = null;
      let value = "";
      if (record["p_property_master_code"]) {
        curRecord = this.getFather(
          this.items_copy,
          record["p_property_master_code"]
        );
      } else {
        return true;
      }
      if (!curRecord) {
        return true;
      } else {
        if (curRecord["changeList"].length) {
          value = this.getTrueValue(
            curRecord.changeList,
            curRecord.data_type,
            curRecord.prompt_name,
            curRecord
          );
        } else {
          if (curRecord.data_type === "boolean") {
            value =
              curRecord.value.toString() == "1"
                ? this.$t("label_essweb_system_label_trueLabel")
                : curRecord.value.toString() == "0"
                ? this.$t("label_essweb_system_label_falseLabel")
                : curRecord.value;
          } else if (
            curRecord.data_type === "int" ||
            curRecord.data_type === "String" ||
            curRecord.data_type === "bigint"
          ) {
            value = curRecord["value"];
          } else if (curRecord.prompt_name !== "") {
            value =
              curRecord.value.toString() == "1"
                ? this.$t("label_essweb_system_label_trueLabel")
                : curRecord.value.toString() == "0"
                ? this.$t("label_essweb_system_label_falseLabel")
                : curRecord.value;
          } else {
            value = curRecord["value"];
          }
        }
      }
      if (
        value === "" ||
        value === this.$t("label_essweb_system_label_falseLabel")
      ) {
        return false;
      } else {
        return true;
      }
      // if (value !== "") {
      //   if (value === "True") {
      //     return true;
      //   } else if (value !== "False") {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // } else {
      //   return false;
      // }
    },
    getCurEdit2: function (record, listdata) {
      let code = "";
      let value = "";
      let curRecord = null;
      if (record["p_property_master_code"]) {
        curRecord = listdata.find(
          (ele) => ele.property_master_code === record["p_property_master_code"]
        );
      } else {
        return true;
      }
      if (!curRecord) {
        return true;
      } else {
        if (curRecord["changeList"].length) {
          value = this.getTrueValue(
            curRecord.changeList,
            curRecord.data_type,
            curRecord.prompt_name,
            curRecord
          );
        } else {
          //避免value=null造成toString()報錯 2021-07-16
          // if (curRecord.value === null) curRecord.value = "";
          if (curRecord.data_type === "boolean") {
            value =
              curRecord.value.toString() == "1"
                ? this.$t("label_essweb_system_label_trueLabel")
                : curRecord.value.toString() == "0"
                ? this.$t("label_essweb_system_label_falseLabel")
                : curRecord.value;
          } else if (
            curRecord.data_type === "int" ||
            curRecord.data_type === "String" ||
            curRecord.data_type === "bigint"
          ) {
            value = curRecord["value"];
          } else if (curRecord.prompt_name !== "") {
            value =
              curRecord.value.toString() == "1"
                ? this.$t("label_essweb_system_label_trueLabel")
                : curRecord.value.toString() == "0"
                ? this.$t("label_essweb_system_label_falseLabel")
                : curRecord.value;
          } else {
            value = curRecord["value"];
          }
        }
      }
      if (
        value === "" ||
        value === this.$t("label_essweb_system_label_falseLabel")
      ) {
        return false;
      } else {
        return true;
      }
    },
    getPlaceholderCount: function (strSource) {
      //统计字符串中包含{}或{xxXX}的个数

      var thisCount = 0;

      strSource.replace(/\|/g, function (m, i) {
        //m为找到的{xx}元素、i为索引

        thisCount++;
      });

      return thisCount;
    },
    getFather: function (item, code) {
      const that = this;
      var obj = null;
      item.some((it) => {
        if (it["property_master_code"] === code) {
          obj = it;
          return true;
        } else {
          if (it.children) {
            that.getFather(it.children, code);
          }
          // return true;
        }
      });
      return obj;
    },
    tranValue: function () {},
    getOnlineSystemDate: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "hehe",
        url: "/other/get-system-timestamp/",
      }).then((res) => {
        that.curDate = that.$getDateTime(res.data, "YYYY-MM-DD");
      });
    },
    getTrueValue: function (arr, data_type, prompt_name, record) {
      const that = this;
      var value = "";
      let dateArr = [];
      arr.forEach((item) => {
        if (item.effective_utc_datetime != "") {
          if (
            dayjs(item.effective_utc_datetime).isBefore(dayjs(this.curDate))
          ) {
            dateArr.push(that.$getTimeValue(item.effective_utc_datetime));
          }
        }
      });
      if (dateArr.length > 0) {
        // let date = that.$getDateTime(Math.max(true, dateArr), "YYYY-MM-DD");
        dateArr.sort(function (a, b) {
          return a - b;
        });
        let date = that.$getDateTime(dateArr[dateArr.length - 1], "YYYY-MM-DD");
        if (arr.find((item) => item.effective_utc_datetime == date))
          value = arr.find((item) => item.effective_utc_datetime == date)[
            "value"
          ];
      }
      if (data_type === "boolean") {
        value =
          value.toString() == "0"
            ? that.$t("label_essweb_system_label_falseLabel")
            : value.toString() == "1"
            ? that.$t("label_essweb_system_label_trueLabel")
            : value;
      } else if (
        data_type === "int" ||
        data_type === "String" ||
        data_type === "bigint"
      ) {
        value = value.toString();
      } else {
        value = value.toString();
      }
      if (prompt_name != "" && prompt_name != null) {
        // 以prompt_name为准

        if (this.promptArr.indexOf(prompt_name) != -1) {
          return this.getPromptValue(record, value);
        } else {
          value =
            value.toString() == "0"
              ? that.$t("label_essweb_system_label_falseLabel")
              : (value =
                  value.toString() == "1"
                    ? that.$t("label_essweb_system_label_trueLabel")
                    : value);
        }
      } else {
        value = value.toString();
      }

      return value;
    },
    customExpandIcon(props) {
      if (props.expandable) {
        if (props.expanded) {
          return (
            <v-btn
              icon
              onClick={(e) => {
                props.onExpand(props.record, e);
              }}
            >
              <span class="material-icons-round">arrow_drop_down</span>
            </v-btn>
          );
        } else {
          return (
            <v-btn
              icon
              onClick={(e) => {
                props.onExpand(props.record, e);
              }}
            >
              <span class="material-icons-round">arrow_right</span>
            </v-btn>
          );
        }
      } else {
        return <a-icon style="margin-left:36px;" type="suibian" />;
      }
    },

    getGrade: function (text, s) {
      var num = 0;
      if (!text) return num;
      text.forEach((item) => {
        if (item == s) {
          num++;
        }
      });
      return num;
    },
  },
};
</script>
<style >
.cloumn-class {
  background: #f5f5f5;
}
</style>